import { render, staticRenderFns } from "./AppProfileCustomer.vue?vue&type=template&id=171b5620&scoped=true&"
import script from "./AppProfileCustomer.vue?vue&type=script&lang=js&"
export * from "./AppProfileCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171b5620",
  null
  
)

export default component.exports